import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Card,
  useMediaQuery,
  Button,
  IconButton,
} from "@mui/material";
import { format, parseISO } from "date-fns";
import theme from "theme";
import { PendingUserView } from "generated/graphql";
import { P } from "theme/typography";
import { Send } from "@mui/icons-material";

export interface UsersTableProps {
  users: PendingUserView[];
  resendInvite: (email: string) => void;
}

const PendingUserRow = ({
  user,
  resendInvite,
  isMobile,
}: {
  user: PendingUserView;
  resendInvite: (email: string) => void;
  isMobile: boolean;
}) => {
  return (
    <TableRow hover key={user.email} selected={false}>
      <TableCell
        sx={{
          overflow: { xs: "hidden" },
          textOverflow: { xs: "ellipsis" },
        }}>
        {user.email}
      </TableCell>
      {!isMobile && (
        <>
          <TableCell>
            <P>
              {user.firstName ?? ""} {user.lastName ?? ""}
            </P>
          </TableCell>
          <TableCell>{format(parseISO(user.invitedAt), "MM/dd/yyyy")}</TableCell>
          <TableCell>{user.isExpired ? "Expired" : "Active"}</TableCell>
        </>
      )}
      <TableCell>
        {!isMobile ? (
          <Button
            color="default"
            size="small"
            variant="contained"
            onClick={() => resendInvite(user.email)}
            startIcon={<Send />}>
            Resend Invitation
          </Button>
        ) : (
          <IconButton color="default" onClick={() => resendInvite(user.email)}>
            <Send />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

const UsersInviteTable = ({ users, resendInvite }: UsersTableProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <Card
      sx={{
        mt: 2,
        height: "100%",
      }}>
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader sx={{ tableLayout: { xs: "fixed" } }}>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              {!isMobile && (
                <>
                  <TableCell>Name</TableCell>
                  <TableCell>Invite Date</TableCell>
                  <TableCell>Status</TableCell>
                </>
              )}
              <TableCell>Resend</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => {
              return <PendingUserRow key={user.email} user={user} resendInvite={resendInvite} isMobile={isMobile} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default UsersInviteTable;
